import {EditableDate} from './editable-date';

type Props = {
    createdTime: any;
    onUpdateLeadCreatedDate: (arg1?: Date | null | undefined) => void;
};

export function LeadOpenedOn(props: Props) {
    return (
        <EditableDate
            title='Opened on'
            value={props.createdTime}
            onUpdate={props.onUpdateLeadCreatedDate}
            maxDate={new Date()}
            cannedOptions={['yesterday', 'today']}
            saveDateOnYearChange={true}
        />
    );
}
